/**
 * PrinterIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PrinterIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M15.815 2.25c.965 0 1.75.784 1.75 1.75v3.25H20c.966 0 1.75.784 1.75 1.75v7A1.75 1.75 0 0 1 20 17.75h-2.25V20A1.75 1.75 0 0 1 16 21.75H8A1.75 1.75 0 0 1 6.25 20v-2.25H4A1.75 1.75 0 0 1 2.25 16V9c0-.966.784-1.75 1.75-1.75h2.437V4c0-.966.783-1.75 1.75-1.75zM7.75 20c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-5.25h-8.5zM4 8.75a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h2.25V14a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75v2.25H20a.25.25 0 0 0 .25-.25V9a.25.25 0 0 0-.25-.25zm4.187-5a.25.25 0 0 0-.25.25v3.25h8.127V4a.25.25 0 0 0-.25-.25z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PrinterIcon = makeIcon('PrinterIcon', PrinterIconSvg)
